// @ts-nocheck

class DropdownsHelper {
  initialized = false;

  init() {
    if (this.initialized) return;

    this.onClick   = this.handleClick.bind(this);
    this.onKeydown = this.handleKeydown.bind(this);
    this.onScroll  = () => this.closeAll();
    this.onResize  = this.closeAll();

    document.addEventListener('click', this.onClick);
    document.addEventListener('keydown', this.onKeydown);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    this.initialized = true;
  }

  destroy() {
    if (!this.initialized) return;
    document.removeEventListener('click', this.onClick);
    document.removeEventListener('keydown', this.onKeydown);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    this.initialized = false;
  }

  handleClick(e) {
    const btn = e.target.closest('.dropdown-button');

    if (btn) {
      e.stopPropagation();
      const root = btn.closest('.dropdown');
      if (!root) return;

      const wasOpen = root.classList.contains('is-open');
      this.closeAll();
      if (!wasOpen) this.open(root);
      return;
    }

    if (!e.target.closest('.dropdown')) this.closeAll();
  }

  handleKeydown(e) {
    if (e.key === 'Escape') this.closeAll();
  }

  open(root) {
    const button = root.querySelector('.dropdown-button');
    const icon   = button?.querySelector('.icon-arrow');
    const panel  = root.querySelector('.dropdown-content');
    if (!button || !panel) return;

    panel.style.width = 'auto';
    root.classList.add('is-open');
    panel.classList.add('opacity-100', 'pointer-events-auto');
    icon?.classList.add('-rotate-180');
    button.setAttribute('aria-expanded', 'true');

    const br = button.getBoundingClientRect();
    requestAnimationFrame(() => {
      const cr = panel.getBoundingClientRect();
      let left = br.left + br.width / 2 - cr.width / 2;
      const top = br.bottom;

      if (left + cr.width > window.innerWidth) left = window.innerWidth - cr.width - 8;
      if (left < 8) left = 8;

      panel.style.left = `${left}px`;
      panel.style.top  = `${top}px`;
    });
  }

  close(root) {
    const button = root.querySelector('.dropdown-button');
    const icon   = button?.querySelector('.icon-arrow');
    const panel  = root.querySelector('.dropdown-content');

    root.classList.remove('is-open');
    panel?.classList.remove('opacity-100', 'pointer-events-auto');
    icon?.classList.remove('-rotate-180');
    button?.setAttribute('aria-expanded', 'false');
  }

  closeAll() {
    document.querySelectorAll('.dropdown.is-open').forEach(d => this.close(d));
  }
}

export default new DropdownsHelper();
